import { Showcase } from "./pages/Showcase";

// Корень enduser-режима. flowToken приходит из App.tsx (см. detectMode()).
// Если flowToken отсутствует — это невалидный end-user launch.
export default function EndUserMode({
  flowToken,
  autoOpenResourceId,
}: {
  flowToken?: string;
  autoOpenResourceId?: number;
}) {
  if (!flowToken) {
    return (
      <div className="p-6 text-center text-sm">
        откройте витрину по ссылке из потока.
      </div>
    );
  }
  return <Showcase flowToken={flowToken} autoOpenResourceId={autoOpenResourceId} />;
}
